import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useTranslation } from "react-i18next";
import IconAnnouncementIllustrative from "canvas-core-react/lib/IconAnnouncementIllustrative";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";

import useApi from "../../hooks/useApi";

const PendingTasks = () => {
  const [counter, setCounter] = useState(0);

  const history = useHistory();
  const { getApiCAll } = useApi();
  const labels = useTranslation().t("dashboard.pendingTasks", {
    returnObjects: true,
  });

  const getInitialData = async () => {
    try {
      const { data } = await getApiCAll(
        "/providers/number-of-extensions-pending-authorization"
      );
      setCounter(data.data.countExtensionAdmissionPending);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getInitialData();
  }, []);

  return (
    <>
      <h3>{labels.title}</h3>
      <div className="d-flex align-items-center pt-5">
        <div className="position-relative">
          {counter > 0 && (
            <span className="badge badge-danger rounded-circle position-absolute pending-badge-position">
              {counter}
            </span>
          )}
          <IconAnnouncementIllustrative
            size={48}
            className="pending-task-icon"
          />
        </div>
        <p className="mx-4">{labels.mainMessage}</p>
        <PrimaryButton
          onClick={() => history.push("/admissions?page=modifications")}
          className="pending-task-button"
        >
          {labels.button}
        </PrimaryButton>
      </div>
    </>
  );
};

export default PendingTasks;
